



























import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class PregnancyAdvice extends Vue {
  @Prop() public commissioned!: boolean;
  @Prop() public isMobile!: boolean;

  private showContent: boolean = false;

  private toggleContent() {
    this.showContent = !this.showContent;
  }
}
